import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/apiClient';

interface BillingStatus {
  plan_id: string;
  plan_name: string;
  plan_status: string;
  can_access_admin: boolean;
  trial_ends_at?: string;
  plan_limits: {
    max_customers: number;
    max_sources: number;
    ai_queries_per_month: number;
    user_seats: number;
  };
  plan_features: string[];
  current_usage: {
    customers_count: number;
    sources_count: number;
    ai_queries_count: number;
    user_seats_count: number;
  };
}

export function usePlanInfo() {
  return useQuery<BillingStatus>({
    queryKey: ['billing-status'],
    queryFn: () => apiClient.customRequest('/api/billing/status'),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function isTrialPlan(planId?: string): boolean {
  return planId === 'free_trial';
}

export function isPaidPlan(planId?: string): boolean {
  return Boolean(planId && !['free_trial', 'pilot'].includes(planId));
}
